import React from "react";

function Inventory() {
  return (
    <div className="inventory">
      <div className="inventory-title">INVENTORY</div>
      <div className="gradient-wrap-border1">
        <div className="inventory-item">
          <div className="inventory-item-icon"></div>
          <div className="inventory-item-name"></div>
        </div>
      </div>
      <div className="gradient-wrap-border2">
        <div className="inventory-item">
          <div className="inventory-item-icon"></div>
          <div className="inventory-item-name"></div>
        </div>
      </div>
      <div className="gradient-wrap-border3">
        <div className="inventory-item">
          <div className="inventory-item-icon"></div>
          <div className="inventory-item-name"></div>
        </div>
      </div>
      <div className="gradient-wrap-border4">
        <div className="inventory-item">
          <div className="inventory-item-icon"></div>
          <div className="inventory-item-name"></div>
        </div>
      </div>
      <div className="inventory-title">STATS</div>
      <div className="inventory-stats">
        <div className="inventory-stats-item">0000</div>
        <div className="inventory-stats-item">0000</div>
        <div className="inventory-stats-item">0000</div>
      </div>
    </div>
  );
}

export default Inventory;
